import { gql } from '@apollo/client';

export const HEALTH_PLAN_USER = gql`
	query HealthPlanUser(
		$userId: UUID
		$healthPlanCode: String
		$workplaceId: UUID
	) {
		healthPlanUser(
			userId: $userId
			healthPlanCode: $healthPlanCode
			workplaceId: $workplaceId
		) {
			id
			healthPlanId
			healthPlan {
				id
				name
				code
				active
			}
			activeMonth
			doctorId
			offerContent
			statusText
			isActive
			ready
			endAt
			hasEnded
			initialQuestionnaireResult {
				id
				questionnaire {
					id
					code
				}
			}
			doctor {
				id
				profile {
					fullName
				}
			}
			price {
				formattedPrice
			}
			periods {
				label
				value
				sale
				id
			}
			activeFrom
			activeTo
			activatedAt
			pricing {
				paymentMethod
				totalPrice {
					id
					priceWithVat
					currency
					formattedPrice
				}
				payNow {
					id
					priceWithVat
					currency
					formattedPrice
				}
				remainsToPay {
					id
					priceWithVat
					currency
					formattedPrice
				}
				nextPayment {
					id
					priceWithVat
					currency
					formattedPrice
				}
			}
			healthPlanUserBaby {
				gestionalAge
				dateOfBirth
			}
		}
	}
`;
